import React from 'react'
import PropTypes from 'prop-types'

const CONTAINER_CLASSES = 'tw:flex tw:items-center tw:gap-4 tw:pt-4 '
  + 'tw:border-t tw:border-solid tw:border-gray-300'

const LINE_CLASSES = 'tw:inline-block tw:w-8 tw:h-0 tw:border-t-2'

const ChartLegend = ({ actions = null, items }) => (
  <div className={CONTAINER_CLASSES}>
    {items.map(item => (
      <div key={item.label} className="tw:flex tw:items-center tw:gap-1.5">
        <span className={`${LINE_CLASSES} ${item.lineClassName}`} />
        <span className="tw:text-gray-500 tw:text-sm tw:font-medium">
          {item.label}
        </span>
      </div>
    ))}
    {actions}
  </div>
)

ChartLegend.propTypes = {
  actions: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    lineClassName: PropTypes.string.isRequired
  })).isRequired
}

ChartLegend.defaultProps = {
  actions: null
}

export default ChartLegend
